import { format } from 'date-fns';
import { SolutionEdgeWorkloadAuthType } from 'src/pages/Solutions/types';

const getFormattedTokenExpiryDate = (
  tokenExpiryDate?: string
): string | null => {
  if (!tokenExpiryDate) {
    return null;
  }

  const parsedDate = new Date(tokenExpiryDate);
  if (Number.isNaN(parsedDate.getTime())) {
    return tokenExpiryDate;
  }

  return format(parsedDate, "yyyy-MM-dd'T'HH:mm:ss");
};

const getFormattedWorkloadParams = (params: any) => {
  const updatedParams = { ...params };
  const formattedTokenExpiryDate = getFormattedTokenExpiryDate(
    updatedParams.tokenExpiryDate
  );

  updatedParams.tokenExpiryDate = formattedTokenExpiryDate;

  return updatedParams;
};

export const getEdgeWorkloadEditParams = (
  params: any,
  gitFlag?: string | undefined
) => {
  const updatedParams = getFormattedWorkloadParams(params);

  if (updatedParams.gitAuthentication !== SolutionEdgeWorkloadAuthType.HTTPBased) {
    delete updatedParams.gitUsername;
    delete updatedParams.gitPassword;
    delete updatedParams.tokenExpiryDate;
    return {
      WorkloadConfiguration: { ...updatedParams },
    };
  }

  return {
    WorkloadConfiguration: { ...updatedParams },
  };
};

export const getSiteWorkloadEditParams = (params: any, siteId?: string) => {
  const updatedParams = getFormattedWorkloadParams(params);
  const clusterId = updatedParams.siteClusters;
  delete updatedParams.siteClusters;
  return {
    ...updatedParams,
    SiteClusters: [
      {
        SiteId: siteId,
        ClusterIds: clusterId,
      },
    ],
  };
};
